import { ISVGIconProps } from '@northladder/design-system';

/**
 * -----------------------------------------------------------------------------
 * Renders a Close SVG icon with customizable height, width, and className.
 * The icon uses `currentColor` for its stroke, allowing color inheritance from parent elements.
 */
export function CloseSVGIcon({
  height = 32,
  width = 32,
  className,
}: ISVGIconProps) {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 32 32"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Interface, Essential/Delete, Disabled">
        <g id="Group">
          <path
            d="M19.7732 12.2267L12.2266 19.7733"
            id="Path"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M19.7732 19.7733L12.2266 12.2267"
            id="Path_2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            clipRule="evenodd"
            d="M16 28V28C9.372 28 4 22.628 4 16V16C4 9.372 9.372 4 16 4V4C22.628 4 28 9.372 28 16V16C28 22.628 22.628 28 16 28Z"
            fillRule="evenodd"
            id="Path_3"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  );
}
